import { Provider } from '@angular/core';
import { OnboardServiceBootstrapService } from './data-access/onboard-service-bootstrap.service';
import { OnboardService } from './services/onboard.service';

export const ONBOARD_PROVIDERS: Provider[] = [OnboardService, OnboardServiceBootstrapService];
